import { } from 'vue';
import BaseSimplePagedListSetupService from '../BaseSimplePagedListSetupService';
import OrganizationApi from '@/api/OrganizationApi';

type Props = SetupProps<typeof OrganizationReleaseNoteCompanyListSetupService.props>

export default class OrganizationReleaseNoteCompanyListSetupService extends BaseSimplePagedListSetupService<Props, ICompanyItemAvailableForOrganizationModel> {
	// static props = {};

	get listRefresher () { return OrganizationApi.gridAvailableCompanies; }

	get companiesByAgency () {
		const agencies = [...this.list]
			.map(x => ({
				agencyCompanyId: x.agencyCompanyId,
				agencyCompanyName: x.agencyCompanyName,
			}))
			.distinct('agencyCompanyId');

		return agencies.map(x => ({
			...x,
			companies: this.list.filter(y => y.agencyCompanyId === x.agencyCompanyId),
		}));
	}

	constructor (props?: Props) {
		super(props);
	}
}
